module.exports = __webpack_public_path__ + "img/SectorService.cebd877.jpg";